var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-180 32 32)",
    fill: "#020D13",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 12,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 22L16 18.4L19.6 22L21 20.6L17.4 17L21 13.4L19.6 12L16 15.6L12.4 12L11 13.4L14.6 17L11 20.6L12.4 22ZM16 27C14.6167 27 13.3167 26.7373 12.1 26.212C10.8833 25.6873 9.825 24.975 8.925 24.075C8.025 23.175 7.31267 22.1167 6.788 20.9C6.26267 19.6833 6 18.3833 6 17C6 15.6167 6.26267 14.3167 6.788 13.1C7.31267 11.8833 8.025 10.825 8.925 9.925C9.825 9.025 10.8833 8.31233 12.1 7.787C13.3167 7.26233 14.6167 7 16 7C17.3833 7 18.6833 7.26233 19.9 7.787C21.1167 8.31233 22.175 9.025 23.075 9.925C23.975 10.825 24.6873 11.8833 25.212 13.1C25.7373 14.3167 26 15.6167 26 17C26 18.3833 25.7373 19.6833 25.212 20.9C24.6873 22.1167 23.975 23.175 23.075 24.075C22.175 24.975 21.1167 25.6873 19.9 26.212C18.6833 26.7373 17.3833 27 16 27Z",
    fill: "#F04248"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c17c404edd740b77186ce346d537e2e5.svg";
export { ForwardRef as ReactComponent };